/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Enum_DraftInputs */

const cs_enum_draft = /** @type {(inputs: Enum_DraftInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Návrh`)
};

const en_enum_draft = /** @type {(inputs: Enum_DraftInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Draft`)
};

/**
* | output |
* | --- |
* | "Draft" |
*
* @param {Enum_DraftInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const enum_draft = /** @type {((inputs?: Enum_DraftInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Enum_DraftInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_enum_draft(inputs)
	return cs_enum_draft(inputs)
});